import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
    pageFrameWithChildrenCSS,
    pageFrameWithOverlayCSS,
} from './styles/AppStatsPageContent.styles';
import OverlayContext, { Overlays } from '../../common/containers/OverlayContext';
import SearchInputMobile from './SearchInputMobile';
import UserMenuMobile from './Navigation/UserDropdownMenu/UserMenuMobile';
import LogsPageSearchBoxMobile from '../../common/components/LogsPage/LogsPageSearchBoxMobile';
import LogsPageContextConsumer from '../../common/components/LogsPage/LogsPageContextConsumer';
import CustomerStatFilterMobile from './CustomerStatsFilter/CustomerStatFilterMobile';
import LicenseInformationMobile from './Licensing/LicenseInformationMobile';

export default function AppStatsPageContent({ children }) {
    const { overlay } = useContext(OverlayContext);
    // Use "display: none" around the <Outlet /> in order to preserve state in items such as Overlays
    // Do not use if/else statements as this will tell React to destroy the underlying tree
    const [, setSearchParams] = useSearchParams();
    return (
        <>
            {overlay === Overlays.SEARCH ? <SearchInputMobile /> : null}
            {overlay === Overlays.SEARCH_LOGS ? (
                <LogsPageContextConsumer>
                    {({
                        className,
                        placeholder,
                        onSearchTextChange,
                        onItemSelected,
                        searchWords,
                        selectedValue,
                        items,
                        searchText,
                        showSearchResults,
                        setShowSearchResults,
                    }) => (
                        <LogsPageSearchBoxMobile
                            className={className}
                            onItemSelected={onItemSelected}
                            onSearchTextChange={onSearchTextChange}
                            placeholder={placeholder}
                            searchWords={searchWords}
                            items={items}
                            selectedValue={selectedValue}
                            searchText={searchText}
                            showSearchResults={showSearchResults}
                            setShowSearchResults={setShowSearchResults}
                            setSearchParams={setSearchParams}
                        />
                    )}
                </LogsPageContextConsumer>
            ) : null}
            {overlay === Overlays.USER_DROPDOWN ? <UserMenuMobile /> : null}
            {overlay === Overlays.STAT_FILTER ? <CustomerStatFilterMobile /> : null}
            {overlay === Overlays.LICENSE_INFORMATION ? <LicenseInformationMobile /> : null}
            <div css={overlay ? pageFrameWithOverlayCSS : pageFrameWithChildrenCSS}>{children}</div>
        </>
    );
}
AppStatsPageContent.propTypes = {
    children: PropTypes.node,
};
